import React, {Component} from 'react';

import pdf from '../images/fileType/pdf.png';

export default class Credits extends Component {
    
    componentWillMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div className="upper">
                <div className="captions">
                    Формирование приказов по движению контингента переменного состава
                </div>
                <div className="justify-content">
                    <div className="order-left">
                        <div className="justify-content order-left-top">
                            <div>
                                <div className="inputs__name">Тип</div>
                                <div className="inputs__own">Зачисление</div>
                            </div>
                            <div>
                                <div className="inputs__name">Номер</div>
                                <div className="inputs__own">1/2017-К</div>
                            </div>
                            <div>
                                <div className="inputs__name">Дата</div>
                                <div className="inputs__own">01.08.2017</div>
                            </div>
                        </div>

                        <p className="name-input-div">Название</p>
                        <div className="red-border">
                            Приказ Начальника ваенного института о назначении курсантов на воинские должности
                        </div>
                        <p className="name-input-div">Основание</p>
                        <div className="red-border">
                            Решение приемной комиссии о приеме на учебу № 123 от 25.07.2017 г.
                        </div>
                        <table className="order-left-table">
                            <tr>
                                <th className="portfolio-table-title" style={{width: '10%'}}>№</th>
                                <th className="portfolio-table-title">Фамилия имя отчество</th>
                                <th className="portfolio-table-title" style={{width: '15%'}}>Куда</th>
                            </tr>
                            <tr>
                                <td>1</td>
                                <td className="col">Семенов Аркадий Петрович</td>
                                <td>1 курс гр. 17-001</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td className="col">Перламутров Александр Казимироч</td>
                                <td>1 курс гр. 17-001</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td className="col">Стомашевский Савва Данилович</td>
                                <td>1 курс гр. 17-001</td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td className="col">Репетитор Константин Александрович</td>
                                <td>1 курс гр. 17-001</td>
                            </tr>
                        </table>
                        <div className="order-left-button">
                            <button>Добавить</button>
                            <button>Удалить</button>
                        </div>
                    </div>

                    <div className="order-right">
                        <p>Сканкопия приказов</p>
                        <div>
                            <img src={pdf} alt=""/>
                            <p>Решение приемной комисси<br/> от 25.07.2017 г.</p>
                        </div>
                        <div>
                            <img src={pdf} alt=""/>
                            <p>Приказ Начальника военного института о назначении на должность от 01.08.2017 г.</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

